<div class="site-selector" *ngIf="sites?.length > 1">
  <label for="siteSelect">Site:</label>
  <select id="siteSelect" [(ngModel)]="selectedSite" (change)="onChange()">
    <option *ngFor="let site of sites" [value]="site.id">
      {{ site.name }}
    </option>
  </select>
</div>

<!-- Optional: fallback if only one site -->
<div class="site-selector single" *ngIf="sites?.length === 1">
  <label>Site:</label>
  <span>{{ sites[0].name }}</span>
</div>
